import Benchmark from "./Benchamark";
import CreatorConfirmation from "./CreatorConfirmation";
import { Dispatch, SetStateAction, useState } from "react";

type TProjectConfirmModal = {
  setOpen: Dispatch<SetStateAction<boolean>>;
  onClick: (deliverables: string) => void;
  isLoading: boolean;
  jobPrice: number;
  currency: string;
};

const ProjectConfirmationModal = ({
  setOpen,
  onClick,
  currency,
  jobPrice,
  isLoading,
}: TProjectConfirmModal) => {
  const [showBenchMark, setShowBenchMark] = useState(false);
  return (
    <div>
      {showBenchMark ? (
        <Benchmark setShowBenchMark={setShowBenchMark} />
      ) : (
        <CreatorConfirmation
          jobPrice={jobPrice}
          currency={currency}
          setOpen={setOpen}
          onClick={onClick}
          isLoading={isLoading}
          setShowBenchMark={setShowBenchMark}
        />
      )}
    </div>
  );
};

export default ProjectConfirmationModal;
